<template>
    <div class="autocomplete w-100" :id="`autocomplete-container-${id}`">
        <div class="search-field">
            <b-form-group :label="label" :label-for="`autocomplete-input-${id}`">
                <b-input-group>
                    <b-form-input
                        :id="`autocomplete-input-${id}`"
                        v-bind="$attrs"
                        v-on="$listeners"
                        v-model="term"
                        @input="search"
                        @keydown.down="nextResult"
                        @keydown.up="prevResult"
                        @keydown.enter="setResult"
                    ></b-form-input>
                    <b-input-group-append is-text class="input-button" @click="clear">
                        <span @click="clear">
                            <i class="fas fa-times"></i>
                        </span>
                    </b-input-group-append>
                    <b-input-group-append is-text class="input-button" v-if="haveData && !showResults" @click="openResults">
                        <span :id="`autocomplete-open-results-btn-${id}`">
                            <i class="fas fa-caret-up"></i>
                        </span>
                    </b-input-group-append>
                    <b-input-group-append is-text class="input-button" v-else @click="closeResults">
                        <span :id="`autocomplete-clear-btn-${id}`">
                            <i class="fas fa-caret-down"></i>
                        </span>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </div>
        <div :class="`autocomplete-results w-100`" v-if="showResults">
            <ul class="list-group w-100">
                <li
                    @click="choose(i)"
                    class="list-group-item w-100 result-item"
                    v-for="(result, i) in getResult"
                    :key="i"
                    :class="{ 'list-group-item-dark': i === idx }"
                    @mousemove="setIndex(i)"
                >
                    {{ result[textField] }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: '',
        },
        resource: {
            type: String,
            default: '',
        },
        passiveResource: {
            type: Boolean,
            default: false,
        },
        minLength: {
            type: String,
            default: '3',
        },
        options: {
            type: Array,
            default: () => [],
        },
        valueField: {
            type: String,
            default: 'id',
        },
        textField: {
            type: String,
            default: 'name',
        },
        textFields: {
            type: Array,
            default: () => [],
        },
        passiveFields: {
            type: Boolean,
            default: true,
        },
        id: {
            type: String,
            default: () => `${parseInt(Math.random() * 1000000)}`,
        },
        object: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        term: '',
        results: [],
        idx: 0,
    }),
    computed: {
        haveData() {
            return !!this.options.length || !!this.results.length
        },
        showResults() {
            return !!this.results.length
        },
        getResult() {
            if (!!this.textFields.length) {
                return this.searchTextFields(this.results)
            } else {
                return this.searchTextField(this.results)
            }
        },
    },
    methods: {
        search() {
            if (this.term.length < parseInt(this.minLength)) {
                return this.passiveResource ? this.results : (this.results = [])
            }
            if (!!this.options.length) {
                this.searchInOptions()
            } else {
                this.searchInResource()
            }
        },
        getJoinWhenKeys(item, keys) {
            return item['_joinkey'] && this.passiveFields
                ? item['_joinkey']
                : (item['_joinkey'] = Object.keys(item)
                      .filter((i) => keys.find((j) => j == i))
                      .map((key) => item[key])
                      .join(' '))
        },
        searchTextField(data) {
            return data.filter((item) => item[this.textField].toLowerCase().includes(this.term.toLowerCase()))
        },
        searchTextFields(data) {
            return data.filter((item) => {
                let join = this.getJoinWhenKeys(item, this.textFields)
                return join.toLowerCase().includes(this.term.toLowerCase())
            })
        },
        searchInOptions() {
            if (!this.options.length) return

            this.results = this.options
        },
        async searchInResource() {
            if (!this.resource || !!this.results.length) return

            const { data } = await this.$repo.get(this.resource, {
                term: this.term,
            })

            this.results = data
        },
        nextResult() {
            this.idx = Math.min(this.idx + 1, this.results.length - 1)
        },
        prevResult() {
            this.idx = Math.max(this.idx - 1, 0)
        },
        setResult() {
            const result = this.getResult[this.idx]
            if (!result) return this.$emit('selected', null)
            this.term = result[this.textField]
            this.results = this.passiveResource ? this.results : []
            this.$emit('input', this.object ? result : result[this.valueField])
            this.$emit('selected', this.object ? result : result[this.valueField])
        },
        restart() {
            this.results = []
            this.idx = 0
        },
        choose(i) {
            this.idx = i
            this.setResult()
        },
        setIndex(i) {
            this.idx = i
        },
        showOptions() {
            this.term.length = ''
            this.search()
        },
        clear() {
            this.results = []
            this.term = ''
            this.idx = 0
        },
        openResults() {
            this.term = ''
            if (!!this.options.length) return (this.results = this.options)
            this.searchInResource()
        },
        closeResults() {
            this.results = []
        },
    },
    mounted() {
        const self = this

        $(document).on('click', function (event) {
            let autocomplete = document.getElementById(`autocomplete-container-${self.id}`)

            let targetElement = event.target

            do {
                if (targetElement == autocomplete) return

                targetElement = targetElement.parentNode
            } while (targetElement)
            self.restart()
        })
    },
}
</script>
<style scoped>
.autocomplete {
    position: relative;
    display: block;
}
.autocomplete-results {
    position: absolute;
    left: 0;
    top: 70px;
    z-index: 9999;
}
.result-item {
    height: 30px;
    padding: 2px 5px;
    cursor: pointer;
}
.input-button {
    cursor: pointer;
}
</style>
